import { useEffect } from "react";
import { useLocation, useRouteMatch } from "react-router-dom";

export default function usePrepareLink({
  to,
  isRelativePath = false,
  query = {},
  pushToQuery = {},
  hash,
  keepOldQuery = false,
  state = {},
}: any) {
  const location = useLocation();

  console.log("usePrepareLink location:", location);

  const match = useRouteMatch();

  //   console.log("usePrepareLink match:", match);
  //   console.log("usePrepareLink to:", to);

  let pathname;

  if (match && isRelativePath) {
    pathname = match.url + to;
  } else {
    pathname = to || location.pathname;
  }

  const newQuery = keepOldQuery
    ? new URLSearchParams(location.search)
    : new URLSearchParams();

  //   console.log("location before: ", location);

  //   console.log("location.search before: ", location.search);
  //   console.log("newQuery before: ", newQuery);

  Object.entries(query).forEach(([key, value]: any) => {
    newQuery.set(key, value);
  });

  Object.entries(pushToQuery).forEach(([key, value]: any) => {
    const currentValue = newQuery.get(key);
    const splittedValue: any = currentValue ? currentValue.split(",") : [];
    splittedValue.push(value);

    newQuery.set(key, splittedValue);
  });

  //   useEffect(() => {
  //     console.log("usePrepareLink location: ", location);
  //     console.log("usePrepareLink newQuery.toString(): ", newQuery.toString());
  //   }, [location, newQuery]);

  return {
    pathname: pathname.replace(/\/\//g, "/"),
    search: newQuery.toString() ? `?${newQuery.toString()}` : "",
    hash,
    state,
  };
}
